<template>
    <Consent  />
</template>

<script>
// @ is an alias to /src
import Consent from "@/components/Consent.vue";

export default {
  name: "home",
  components: {
    Consent
  }
};
</script>
